<div class="fx_footer">

  <!-- 图片模块 -->
      <div class="fx_icons">
        <div class="fx_container">
            <div class="fx_icon_group" *ngFor="let item of footerList" (click)="linkTo('home', item.dfa005)">
              <p><img src="{{item.dfa004}}" /></p>
              <p>{{item.dfa002}}</p>
            </div>
        </div>
      </div>



    <div class="fx_container fx_container_footer">
      <div class="fx_servers">
        <div class="fx_servers_left">
          <div class="fx_servers_hepleList" *ngFor="let item of helpService">
            <p (click)="linkTo('home/helpcenter', item.child.length ? item.child[0].dfa001 : '')">{{item.aaa002_n1}}</p>
            <ol>
              <li *ngFor="let child of item.child" (click)="linkTo('home/helpcenter', child.dfa001)">{{child.dfa002}}</li>
            </ol>
          </div>

        </div>
        <div class="fx_servers_right">
          <div class="fx_foot_code" *ngFor="let item of qrCode">
            <img src="{{item.dfa004}}" />
            <p>{{item.dfa002}}</p>
          </div>
          <div class="fx_foot_content">
            <ol>
              <li *ngFor="let item of contactList">
                <div class="fx_content_icon"><img src="{{item.dfa004}}" /></div>
                <div class="fx_content_text">
                  <h1>{{item.dfa002}}</h1>
                  <a [ngClass]="{'fx_bussiness_tell': item.dfa006 == '2'}" href="mailto:{{item.dfa003}}">{{item.dfa003}}</a>
                </div>
              </li>

            </ol>
          </div>
        </div>
      </div>

      <!-- 友情链接 -->
      <div class="fx_friend_link">
        <div class="fx_friend_link_title">{{'fxed020-友情链接' | translate}}</div>
        <div class="fx_friend_link_url">
          <a *ngFor="let item of friends" href="{{item.dfa005}}" target="_blank">{{item.dfa002}}</a>
        </div>
      </div>

      <!-- 对应底部一、底部二、底部三 -->
      <div class="fx_about_link">
        <div class="fx_about_link01">
          <ul>
            <li *ngFor="let group1 of footer01" (click)="fxAboutlink(group1)">{{group1.dfa002}}<em>|</em></li>
          </ul>
        </div>
        <ul class="fx_about_link02">
            <li *ngFor="let group2 of footer02" (click)="fxAboutlink(group2)">{{group2.dfa002}}<em>|</em></li>
        </ul>
        <ul class="fx_about_link03">
          <li *ngFor="let group3 of footer03" (click)="fxAboutlink(group3)">{{group3.dfa002}}</li>
        </ul>
      </div>
    </div>

</div>
